<template>
  <div id="icons" class="card border-0">
    <div class="row">
      <div class="col-6 col-sm-4 col-lg-3 col-xxl-2 text-center mb-4" 
        v-for="icon in searchIconsMatch"
        :key="icon"
      >
        <div class="p-1 m-1 text-center">
          <Icon :iconName="icon"></Icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/icons/Icon.vue'
import icons from '@/components/icons/icons.js'

let description = 'Icons'

export default {
  name: 'Icons',
  components: {
    Icon
  },
  data () {
    return {
      icons,
    }
  },
  beforeCreate: function () {
    this.$emit('update-icon-name', this.$options.name, this.$options.name) 
    this.$emit('update-icon-description', this.$options.name, description) 
    this.$emit('update-icon-number-of-icons', this.$options.name, icons.length)
  },
  computed: {
    // Function tied to search feature of Iconography.vue
    searchIconsMatch: function () {
      this.$emit('search-icons', this.$options.name, this.icons)
      if (this.searchResult['name'] === this.$options.name) {
        this.$emit('update-icon-number-of-icons', this.$options.name, this.searchResult['result'].length)
        return this.searchResult['result']
      }
      return icons
    }
  },
  props: {
    searchResult: Object
  }
}
</script>